import React from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import LoginMenu from './../../../containers/shared/LoginMenu';
import UserPanel from './../user-panel/user-panel';
import { Template } from 'devextreme-react/core/template';

import './header.scss';



export default ({ menuToggleEnabled, title, toggleMenu, panelMenuItems }) => (
    <header className={'header-component'}>
        <Toolbar className={'header-toolbar'}>
            <Item
                visible={menuToggleEnabled}
                location={'before'}
                widget={'dxButton'}
                cssClass={'menu-button'}
                options={{
                    icon: 'menu',
                    stylingMode: 'text',
                    onClick: toggleMenu
                }}
            />
            <Item
                location={'before'}
                cssClass={'header-title'}
                text={title}
                visible={!!title}
            />
            <Item
                location={'after'}
                locateInMenu={'auto'}
                menuItemTemplate={'userPanelTemplate'}
            >
                <LoginMenu />
            </Item>

            <Template name={'userPanelTemplate'}>
                <UserPanel menuItems={panelMenuItems} menuMode={'list'} />
            </Template>

        </Toolbar>
    </header>
);

